export default __webpack_public_path__ + "static/media/13.6ec92a17.gif";